import { styled } from '@mui/material/styles';
import { FormattedMessage } from 'react-intl';
import Modal from '@/components/Modal/Modal';
import FeedbackForm from './FeedbackForm';

type FeedbackModalProps = {
  open: boolean;
  onClose: () => void;
};

const FeedbackModal = ({ open, onClose }: FeedbackModalProps) => (
  <WideModal
    open={open}
    onClose={onClose}
    title={
      <FormattedMessage
        id="feedbackWidget.title"
        defaultMessage="Share your Feedback"
      />
    }
  >
    <FeedbackForm variant="plain" isActive={open} onClose={onClose} />
  </WideModal>
);

const WideModal = styled(Modal)({
  width: 520,
  maxWidth: 'calc(100vw - 32px)',
});

export default FeedbackModal;
